/* eslint-disable global-require */
module.exports = [...require('./Artists/i18n'), ...require('./Contact/i18n'), ...require('./Informations/i18n'), ...require('./Preview/i18n'), 'marketplace.stores.edit.form.m1'];
